function formatFileSize(size) {

    if (size <= 0) {
        return "0 B";
    }
    const units = ["B", "kB", "MB", "GB", "TB"];
    const digitGroups = Math.min(Math.floor(Math.log10(size) / Math.log10(1024)), units.length - 1);

    const value = new Intl.NumberFormat("de-DE", {
        maximumFractionDigits: 1
    }).format(
        size / Math.pow(1024, digitGroups)
    );

    return `${value} ${units[digitGroups]}`;
}

export {formatFileSize};